import * as React from "react";
const SvgWarning = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "48px", height: "48px", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M1 21h22L12 2zm12-3h-2v-2h2zm0-4h-2v-4h2z" }));
export default SvgWarning;
